import { render, staticRenderFns } from "./TagsSidebarSkeleton.vue?vue&type=template&id=a37b0c9e"
import script from "./TagsSidebarSkeleton.vue?vue&type=script&lang=js"
export * from "./TagsSidebarSkeleton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports